import StrictValidationStrategy from './StrictValidationStrategy';
import LinkedinValidationStrategy from './LinkedinValidationStrategy';
import FacebookValidationStrategy from './FacebookValidationStrategy';

class ValidationStrategyFactory {
  static createStrategy(target) {
    switch (target?.toLowerCase()) {
      case 'google':
        return new StrictValidationStrategy();
      case 'linkedin':
        return new LinkedinValidationStrategy();
      case 'facebook':
        return new FacebookValidationStrategy();
      default:
        console.warn(`Unknown validation strategy for this target: ${target}, falling back to strict`);
        return new StrictValidationStrategy();
    }
  }
}

export default ValidationStrategyFactory;